/* eslint-disable eqeqeq */
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../framework/form/FormFw";
import GridFw from "../../../../framework/grid/GridFw";
import { BasePage } from "../../../../framework/pages/BasePage";
import { ModalContext } from "../../../../provider/ModalProvider";
import { MessageUtil } from "../../../../util/MessageUtil";

export class SubparametroResultadosRuidoModal extends BasePage {
  static contextType = ModalContext;

  createPageProperties = (pageApi) => {
    return {
      title: "Ingreso de Resultados",
    };
  };

  renderPage(pageApi) {
    const getGridParametros = () => pageApi.getComponent("parametrosGrid");
    const getFormMetereo = () => pageApi.getComponent("formCondMetereo");
    const barHeaderConfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SAVE,
          onClick: () => {
            pageApi.name.guardarCambios(
              getFormMetereo().getData()?.condiciones_metereologicas,
            );
            getGridParametros().save();
            MessageUtil("success", "Se actualizó correctamente")
          },
        },
        { ...BUTTON_DEFAULT.RETURN, onClick: () => this.context.hideModal() },
      ],
    };

    const formCondMetereo = {
      layout: "vertical",
      fields: [
        {
          type: "textarea",
          value: pageApi.name.data?.condiciones_metereologicas,
          name: "condiciones_metereologicas",
          label: "Ingrese Condiciones Metereológicas",
          column: 12,
        },
      ],
    };

    const gridConfig = {
      rowId: "id_cadena_subparametro",
      showIndex: false,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 934,
        params: () => {
          return {
            muestra: pageApi?.name.data?.muestra,
            id_cadena: pageApi?.name.data?.id_cadena,
          };
        },
      },
      save: {
        queryId: 927,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "sub_parametro", label: "Sub Parámetro" },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          labelName: "desUM",
          column: 4,
          search: true,
          editable: true,
          load: {
            queryId: 583,
            params: () => {
              return {
                id_metodo: getGridParametros().itemEditing.id_metodo,
              };
            },
          },
        },
        {
          name: "resultado",
          label: "Resultado",
          editable: true,
        },
        { name: "incertidumbre", label: "Incertidumbre", editable: true },
      ],
    };

    return (
      <>
        <GridFw
          name="parametrosGrid"
          getParentApi={pageApi.getApi}
          config={gridConfig}
        />
        <FormFw
          name="formCondMetereo"
          getParentApi={pageApi.getApi}
          config={formCondMetereo}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    );
  }
}
